import React, { ChangeEvent, useCallback } from "react";
import classNames from "classnames";

import styles from "./style.module.scss";
import { MessageID } from "../../i18n/types";
import { useI18n } from "../../i18n";

export interface TextFieldProps {
  className?: string;
  inputClassname?: string;
  labelMessageId: MessageID;
  inputName: string;
  placeholderMessageID?: MessageID;
  inputType: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >["type"];
  onTextChange?: (text: string) => void;
  value: string;
  autoFocus?: boolean;
  autoComplete?: string;
  alertText?: string;
  hintText?: string;
  disabled?: boolean;
}

const TextField: React.FC<TextFieldProps> = props => {
  const i18n = useI18n();
  const {
    className,
    inputClassname,
    labelMessageId,
    inputName,
    placeholderMessageID,
    inputType,
    alertText,
    hintText,
    value,
    autoFocus,
    onTextChange,
    autoComplete,
    disabled,
  } = props;
  const handleTextChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (onTextChange) {
        onTextChange(event.currentTarget.value);
      }
    },
    [onTextChange]
  );
  const isDisabled = disabled || false;
  return (
    <div className={classNames(styles.textField, className)}>
      <label className={styles.title}>{i18n.translate(labelMessageId)}</label>
      <input
        name={inputName}
        placeholder={
          placeholderMessageID != null
            ? i18n.translate(placeholderMessageID)
            : undefined
        }
        type={inputType}
        value={value ? value : ""}
        onChange={handleTextChange}
        className={classNames(styles.input, inputClassname, {
          [styles.error]: alertText && alertText !== "",
          [styles.disabled]: isDisabled,
        })}
        autoComplete={autoComplete}
        disabled={isDisabled}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
      />
      <p className={styles.hintText}>{hintText ? hintText : ""}</p>
      <p className={styles.alertText}>{alertText ? alertText : ""}</p>
    </div>
  );
};

export default TextField;
